import React from "react";
import { NavLink as RouterLink, useLocation } from "react-router-dom";

import {
  Button,
  List,
  ListItemButton,
  ListItem,
  Typography,
  Divider,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import Collapse from "@mui/material/Collapse";

const NavItemdropdown = () => {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const splitLoc = splitLocation[3];
  const splitLoc1 = splitLocation[2];

  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  const [open1, setOpen1] = React.useState(false);

  const handleClick1 = () => {
    setOpen1(!open1);
  };

  const [open2, setOpen2] = React.useState(false);

  const handleClick2 = () => {
    setOpen2(!open2);
  };

  const [open3, setOpen3] = React.useState(false);

  const handleClick3 = () => {
    setOpen3(!open3);
  };

  const [open4, setOpen4] = React.useState(false);

  const handleClick4 = () => {
    setOpen4(!open4);
  };

  const [open5, setOpen5] = React.useState(false);

  const handleClick5 = () => {
    setOpen5(!open5);
  };

  const [open6, setOpen6] = React.useState(false);

  const handleClick6 = () => {
    setOpen6(!open6);
  };

  const [open7, setOpen7] = React.useState(false);

  const handleClick7 = () => {
    setOpen7(!open7);
  };

  const [open8, setOpen8] = React.useState(false);

  const handleClick8 = () => {
    setOpen8(!open8);
  };

  return (
    <>
      <ListItemButton
        disableGutters
        sx={{
          display: "flex",
          py: 0.5,
          pl: 1,
        }}
        onClick={handleClick}
      >
        <Typography color="white" variant="h6">
          Preconfigured
        </Typography>
        {open ? (
          <ArrowDropUpIcon style={{ marginLeft: "auto", color: "white" }} />
        ) : (
          <ArrowDropDownIcon style={{ marginLeft: "auto", color: "white" }} />
        )}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Divider style={{ backgroundColor: "rgb(6 57 108)" }} />
        <List component="div" disablePadding>
          <li className="px-3 rounded-lg mb-1 text-gray-700">
            {localStorage.getItem("group") === "admin" ||
              localStorage.getItem("group") === "ops_users" ? (
              <ListItem
                disableGutters
                sx={{
                  display: "flex",
                  py: 0,
                }}
              >
                <Button
                  component={RouterLink}
                  sx={{
                    color: "#ffff",
                    fontWeight: "medium",
                    justifyContent: "flex-start",
                    letterSpacing: 0,
                    py: 0.5,
                    textTransform: "none",
                    width: "100%",
                    ...(splitLoc === "labrequest"
                      ? {
                        backgroundColor: "rgb(6 57 108)",
                        color: "#2cbcd3",
                      }
                      : ""),
                    "& svg": {
                      mr: 1,
                    },
                  }}
                  to="/app/maindeployment/labrequest"
                >
                  <span>Request</span>
                </Button>
              </ListItem>
            ) : (
              ""
            )}

            <ListItem
              disableGutters
              sx={{
                display: "flex",
                py: 0,
              }}
            >
              <Button
                component={RouterLink}
                sx={{
                  color: "#ffff",
                  fontWeight: "medium",
                  justifyContent: "flex-start",
                  letterSpacing: 0,
                  py: 0.5,
                  textTransform: "none",
                  width: "100%",
                  ...(splitLoc === "preconfig"
                    ? {
                      backgroundColor: "rgb(6 57 108)",
                      color: "#2cbcd3",
                    }
                    : ""),
                  "& svg": {
                    mr: 1,
                  },
                }}
                to="/app/instance/preconfig"
              >
                <span>Running Labs</span>
              </Button>
            </ListItem>

            <ListItem
              disableGutters
              sx={{
                display: "flex",
                py: 0,
              }}
            >
              <Button
                component={RouterLink}
                sx={{
                  color: "#ffff",
                  fontWeight: "medium",
                  justifyContent: "flex-start",
                  letterSpacing: 0,
                  py: 0.5,
                  textTransform: "none",
                  width: "100%",
                  ...(splitLoc1 === "schedule"
                    ? {
                      backgroundColor: "rgb(6 57 108)",
                      color: "#2cbcd3",
                    }
                    : ""),
                  "& svg": {
                    mr: 1,
                  },
                }}
                to="/app/schedule"
              >
                <span>Schedule</span>
              </Button>
            </ListItem>
          </li>
        </List>
      </Collapse>
      <ListItemButton
        disableGutters
        sx={{
          display: "flex",
          py: 0.5,
          pl: 1,
        }}
        onClick={handleClick1}
      >
        <Typography color="white" variant="h6">
          Custom
        </Typography>
        {open1 ? (
          <ArrowDropUpIcon style={{ marginLeft: "auto", color: "white" }} />
        ) : (
          <ArrowDropDownIcon style={{ marginLeft: "auto", color: "white" }} />
        )}
      </ListItemButton>
      <Collapse in={open1} timeout="auto" unmountOnExit>
        <Divider style={{ backgroundColor: "rgb(6 57 108)" }} />
        <List component="div" disablePadding>
          <li className="px-3 rounded-lg mb-1 text-gray-700">
            {localStorage.getItem("group") === "admin" ||
              localStorage.getItem("group") === "ops_users" ? (
              <ListItem
                disableGutters
                sx={{
                  display: "flex",
                  py: 0,
                }}
              >
                <Button
                  component={RouterLink}
                  sx={{
                    color: "#ffff",
                    fontWeight: "medium",
                    justifyContent: "flex-start",
                    letterSpacing: 0,
                    py: 0.5,
                    textTransform: "none",
                    width: "100%",
                    ...(splitLoc === "instancerequest"
                      ? {
                        backgroundColor: "rgb(6 57 108)",
                        color: "#2cbcd3",
                      }
                      : ""),
                    "& svg": {
                      mr: 1,
                    },
                  }}
                  to="/app/maindeployment/instancerequest"
                >
                  <span>Request</span>
                </Button>
              </ListItem>
            ) : (
              ""
            )}

            <ListItem
              disableGutters
              sx={{
                display: "flex",
                py: 0,
              }}
            >
              <Button
                component={RouterLink}
                sx={{
                  color: "#ffff",
                  fontWeight: "medium",
                  justifyContent: "flex-start",
                  letterSpacing: 0,
                  py: 0.5,
                  textTransform: "none",
                  width: "100%",
                  ...(splitLoc === "custom"
                    ? {
                      backgroundColor: "rgb(6 57 108)",
                      color: "#2cbcd3",
                    }
                    : ""),
                  "& svg": {
                    mr: 1,
                  },
                }}
                to="/app/instance/custom"
              >
                <span>Running Labs</span>
              </Button>
            </ListItem>

            <ListItem
              disableGutters
              sx={{
                display: "flex",
                py: 0,
              }}
            >
              <Button
                component={RouterLink}
                sx={{
                  color: "#ffff",
                  fontWeight: "medium",
                  justifyContent: "flex-start",
                  letterSpacing: 0,
                  py: 0.5,
                  textTransform: "none",
                  width: "100%",
                  ...(splitLoc1 === "customschedule"
                    ? {
                      backgroundColor: "rgb(6 57 108)",
                      color: "#2cbcd3",
                    }
                    : ""),
                  "& svg": {
                    mr: 1,
                  },
                }}
                to="/app/customschedule"
              >
                <span>Schedule</span>
              </Button>
            </ListItem>
          </li>
        </List>
      </Collapse>
      <ListItemButton
        disableGutters
        sx={{
          display: "flex",
          py: 0.5,
          pl: 1,
        }}
        onClick={handleClick2}
      >
        <Typography color="white" variant="h6">
          Hypervised
        </Typography>
        {open2 ? (
          <ArrowDropUpIcon style={{ marginLeft: "auto", color: "white" }} />
        ) : (
          <ArrowDropDownIcon style={{ marginLeft: "auto", color: "white" }} />
        )}
      </ListItemButton>
      <Collapse in={open2} timeout="auto" unmountOnExit>
        <Divider style={{ backgroundColor: "rgb(6 57 108)" }} />
        <List component="div" disablePadding>
          <li className="px-3 rounded-lg mb-1 text-gray-700">
            {localStorage.getItem("group") === "admin" ||
              localStorage.getItem("group") === "ops_users" ? (
              <ListItem
                disableGutters
                sx={{
                  display: "flex",
                  py: 0,
                }}
              >
                <Button
                  component={RouterLink}
                  sx={{
                    color: "#ffff",
                    fontWeight: "medium",
                    justifyContent: "flex-start",
                    letterSpacing: 0,
                    py: 0.5,
                    textTransform: "none",
                    width: "100%",
                    ...(splitLoc === "hvminstance"
                      ? {
                        backgroundColor: "rgb(6 57 108)",
                        color: "#2cbcd3",
                      }
                      : ""),
                    "& svg": {
                      mr: 1,
                    },
                  }}
                  to="/app/maindeployment/hvminstance"
                >
                  <span>Request</span>
                </Button>
              </ListItem>
            ) : (
              ""
            )}

            <ListItem
              disableGutters
              sx={{
                display: "flex",
                py: 0,
              }}
            >
              <Button
                component={RouterLink}
                sx={{
                  color: "#ffff",
                  fontWeight: "medium",
                  justifyContent: "flex-start",
                  letterSpacing: 0,
                  py: 0.5,
                  textTransform: "none",
                  width: "100%",
                  ...(splitLoc === "hypervisedcustom"
                    ? {
                      backgroundColor: "rgb(6 57 108)",
                      color: "#2cbcd3",
                    }
                    : ""),
                  "& svg": {
                    mr: 1,
                  },
                }}
                to="/app/instance/hypervisedcustom"
              >
                <span>Running Labs</span>
              </Button>
            </ListItem>

            <ListItem
              disableGutters
              sx={{
                display: "flex",
                py: 0,
              }}
            >
              <Button
                component={RouterLink}
                sx={{
                  color: "#ffff",
                  fontWeight: "medium",
                  justifyContent: "flex-start",
                  letterSpacing: 0,
                  py: 0.5,
                  textTransform: "none",
                  width: "100%",
                  ...(splitLoc1 === "hvmschedule"
                    ? {
                      backgroundColor: "rgb(6 57 108)",
                      color: "#2cbcd3",
                    }
                    : ""),
                  "& svg": {
                    mr: 1,
                  },
                }}
                to="/app/hvmschedule"
              >
                <span>Schedule</span>
              </Button>
            </ListItem>
          </li>
        </List>
      </Collapse>
      <ListItemButton
        disableGutters
        sx={{
          display: "flex",
          py: 0.5,
          pl: 1,
        }}
        onClick={handleClick3}
      >
        <Typography color="white" variant="h6">
          Shared
        </Typography>
        {open3 ? (
          <ArrowDropUpIcon style={{ marginLeft: "auto", color: "white" }} />
        ) : (
          <ArrowDropDownIcon style={{ marginLeft: "auto", color: "white" }} />
        )}
      </ListItemButton>
      <Collapse in={open3} timeout="auto" unmountOnExit>
        <Divider style={{ backgroundColor: "rgb(6 57 108)" }} />
        <List component="div" disablePadding>
          <li className="px-3 rounded-lg mb-1 text-gray-700">
            {localStorage.getItem("group") === "admin" ||
              localStorage.getItem("group") === "ops_users" ? (
              <ListItem
                disableGutters
                sx={{
                  display: "flex",
                  py: 0,
                }}
              >
                <Button
                  component={RouterLink}
                  sx={{
                    color: "#ffff",
                    fontWeight: "medium",
                    justifyContent: "flex-start",
                    letterSpacing: 0,
                    py: 0.5,
                    textTransform: "none",
                    width: "100%",
                    ...(splitLoc === "sharedvminstance"
                      ? {
                        backgroundColor: "rgb(6 57 108)",
                        color: "#2cbcd3",
                      }
                      : ""),
                    "& svg": {
                      mr: 1,
                    },
                  }}
                  to="/app/maindeployment/sharedvminstance"
                >
                  <span>Request</span>
                </Button>
              </ListItem>
            ) : (
              ""
            )}

            <ListItem
              disableGutters
              sx={{
                display: "flex",
                py: 0,
              }}
            >
              <Button
                component={RouterLink}
                sx={{
                  color: "#ffff",
                  fontWeight: "medium",
                  justifyContent: "flex-start",
                  letterSpacing: 0,
                  py: 0.5,
                  textTransform: "none",
                  width: "100%",
                  ...(splitLoc === "sharedvm"
                    ? {
                      backgroundColor: "rgb(6 57 108)",
                      color: "#2cbcd3",
                    }
                    : ""),
                  "& svg": {
                    mr: 1,
                  },
                }}
                to="/app/instance/sharedvm"
              >
                <span>Running Labs</span>
              </Button>
            </ListItem>

            <ListItem
              disableGutters
              sx={{
                display: "flex",
                py: 0,
              }}
            >
              <Button
                component={RouterLink}
                sx={{
                  color: "#ffff",
                  fontWeight: "medium",
                  justifyContent: "flex-start",
                  letterSpacing: 0,
                  py: 0.5,
                  textTransform: "none",
                  width: "100%",
                  ...(splitLoc1 === "svmschedule"
                    ? {
                      backgroundColor: "rgb(6 57 108)",
                      color: "#2cbcd3",
                    }
                    : ""),
                  "& svg": {
                    mr: 1,
                  },
                }}
                to="/app/svmschedule"
              >
                <span>Schedule</span>
              </Button>
            </ListItem>


          </li>
        </List>
      </Collapse>
      <ListItemButton
        disableGutters
        sx={{
          display: "flex",
          py: 0.5,
          pl: 1,
        }}
        onClick={handleClick4}
      >
        <Typography color="white" variant="h6">
          Wise
        </Typography>
        {open4 ? (
          <ArrowDropUpIcon style={{ marginLeft: "auto", color: "white" }} />
        ) : (
          <ArrowDropDownIcon style={{ marginLeft: "auto", color: "white" }} />
        )}
      </ListItemButton>
      <Collapse in={open4} timeout="auto" unmountOnExit>
        <Divider style={{ backgroundColor: "rgb(6 57 108)" }} />
        <List component="div" disablePadding>
          <li className="px-3 rounded-lg mb-1 text-gray-700">
            {localStorage.getItem("group") === "admin" ||
              localStorage.getItem("group") === "ops_users" ? (
              <ListItem
                disableGutters
                sx={{
                  display: "flex",
                  py: 0,
                }}
              >
                <Button
                  component={RouterLink}
                  sx={{
                    color: "#ffff",
                    fontWeight: "medium",
                    justifyContent: "flex-start",
                    letterSpacing: 0,
                    py: 0.5,
                    textTransform: "none",
                    width: "100%",
                    ...(splitLoc === "wiserequest"
                      ? {
                        backgroundColor: "rgb(6 57 108)",
                        color: "#2cbcd3",
                      }
                      : ""),
                    "& svg": {
                      mr: 1,
                    },
                  }}
                  to="/app/maindeployment/wiserequest"
                >
                  <span>Request</span>
                </Button>
              </ListItem>
            ) : (
              ""
            )}

            <ListItem
              disableGutters
              sx={{
                display: "flex",
                py: 0,
              }}
            >
              <Button
                component={RouterLink}
                sx={{
                  color: "#ffff",
                  fontWeight: "medium",
                  justifyContent: "flex-start",
                  letterSpacing: 0,
                  py: 0.5,
                  textTransform: "none",
                  width: "100%",
                  ...(splitLoc === "wiselabs"
                    ? {
                      backgroundColor: "rgb(6 57 108)",
                      color: "#2cbcd3",
                    }
                    : ""),
                  "& svg": {
                    mr: 1,
                  },
                }}
                to="/app/instance/wiselabs"
              >
                <span>Running Labs</span>
              </Button>
            </ListItem>

            <ListItem
              disableGutters
              sx={{
                display: "flex",
                py: 0,
              }}
            >
              <Button
                component={RouterLink}
                sx={{
                  color: "#ffff",
                  fontWeight: "medium",
                  justifyContent: "flex-start",
                  letterSpacing: 0,
                  py: 0.5,
                  textTransform: "none",
                  width: "100%",
                  ...(splitLoc1 === "wiseschedule"
                    ? {
                      backgroundColor: "rgb(6 57 108)",
                      color: "#2cbcd3",
                    }
                    : ""),
                  "& svg": {
                    mr: 1,
                  },
                }}
                to="/app/wiseschedule"
              >
                <span>Schedule</span>
              </Button>
            </ListItem>
          </li>
        </List>
      </Collapse>
      <ListItemButton
        disableGutters
        sx={{
          display: "flex",
          py: 0.5,
          pl: 1,
        }}
        onClick={handleClick5}
      >
        <Typography color="white" variant="h6">
          Cloud
        </Typography>
        {open5 ? (
          <ArrowDropUpIcon style={{ marginLeft: "auto", color: "white" }} />
        ) : (
          <ArrowDropDownIcon style={{ marginLeft: "auto", color: "white" }} />
        )}
      </ListItemButton>
      <Collapse in={open5} timeout="auto" unmountOnExit>
        <Divider style={{ backgroundColor: "rgb(6 57 108)" }} />
        <List component="div" disablePadding>
          <li className="px-3 rounded-lg mb-1 text-gray-700">
            {localStorage.getItem("group") === "admin" ||
              localStorage.getItem("group") === "ops_users" ? (
              <ListItem
                disableGutters
                sx={{
                  display: "flex",
                  py: 0,
                }}
              >
                <Button
                  component={RouterLink}
                  sx={{
                    color: "#ffff",
                    fontWeight: "medium",
                    justifyContent: "flex-start",
                    letterSpacing: 0,
                    py: 0.5,
                    textTransform: "none",
                    width: "100%",
                    ...(splitLoc === "cloudrequest"
                      ? {
                        backgroundColor: "rgb(6 57 108)",
                        color: "#2cbcd3",
                      }
                      : ""),
                    "& svg": {
                      mr: 1,
                    },
                  }}
                  to="/app/maindeployment/cloudrequest"
                >
                  <span>Request</span>
                </Button>
              </ListItem>
            ) : (
              ""
            )}

            <ListItem
              disableGutters
              sx={{
                display: "flex",
                py: 0,
              }}
            >
              <Button
                component={RouterLink}
                sx={{
                  color: "#ffff",
                  fontWeight: "medium",
                  justifyContent: "flex-start",
                  letterSpacing: 0,
                  py: 0.5,
                  textTransform: "none",
                  width: "100%",
                  ...(splitLoc === "cloudlabs"
                    ? {
                      backgroundColor: "rgb(6 57 108)",
                      color: "#2cbcd3",
                    }
                    : ""),
                  "& svg": {
                    mr: 1,
                  },
                }}
                to="/app/instance/cloudlabs"
              >
                <span>Running Labs</span>
              </Button>
            </ListItem>

            <ListItem
              disableGutters
              sx={{
                display: "flex",
                py: 0,
              }}
            >
              <Button
                component={RouterLink}
                sx={{
                  color: "#ffff",
                  fontWeight: "medium",
                  justifyContent: "flex-start",
                  letterSpacing: 0,
                  py: 0.5,
                  textTransform: "none",
                  width: "100%",
                  ...(splitLoc1 === "cloudschedule"
                    ? {
                      backgroundColor: "rgb(6 57 108)",
                      color: "#2cbcd3",
                    }
                    : ""),
                  "& svg": {
                    mr: 1,
                  },
                }}
                to="/app/cloudschedule"
              >
                <span>Schedule</span>
              </Button>
            </ListItem>
          </li>
        </List>
      </Collapse>
      
      <ListItemButton
        disableGutters
        sx={{
          display: "flex",
          py: 0.5,
          pl: 1,
        }}
        onClick={handleClick7}
      >
        <Typography color="white" variant="h6">
          Manual
        </Typography>
        {open7 ? (
          <ArrowDropUpIcon style={{ marginLeft: "auto", color: "white" }} />
        ) : (
          <ArrowDropDownIcon style={{ marginLeft: "auto", color: "white" }} />
        )}
      </ListItemButton>
      <Collapse in={open7} timeout="auto" unmountOnExit>
        <Divider style={{ backgroundColor: "rgb(6 57 108)" }} />
        <List component="div" disablePadding>
          <li className="px-3 rounded-lg mb-1 text-gray-700">
            <ListItem
              disableGutters
              sx={{
                display: "flex",
                py: 0,
              }}
            >
              <Button
                component={RouterLink}
                sx={{
                  color: "#ffff",
                  fontWeight: "medium",
                  justifyContent: "flex-start",
                  letterSpacing: 0,
                  py: 0.5,
                  textTransform: "none",
                  width: "100%",
                  ...(splitLoc === "manuallabs"
                    ? {
                      backgroundColor: "rgb(6 57 108)",
                      color: "#2cbcd3",
                    }
                    : ""),
                  "& svg": {
                    mr: 1,
                  },
                }}
                to="/app/instance/manual"
              >
                <span>Running Labs</span>
              </Button>
            </ListItem>

          </li>
        </List>
      </Collapse>
      <ListItemButton
        disableGutters
        sx={{
          display: "flex",
          py: 0.5,
          pl: 1,
        }}
        onClick={handleClick8}
      >
        <Typography color="white" variant="h6">
          SaaS
        </Typography>
        {open8 ? (
          <ArrowDropUpIcon style={{ marginLeft: "auto", color: "white" }} />
        ) : (
          <ArrowDropDownIcon style={{ marginLeft: "auto", color: "white" }} />
        )}
      </ListItemButton>
      <Collapse in={open8} timeout="auto" unmountOnExit>
        <Divider style={{ backgroundColor: "rgb(6 57 108)" }} />
        <List component="div" disablePadding>
          <li className="px-3 rounded-lg mb-1 text-gray-700">
            <ListItem
              disableGutters
              sx={{
                display: "flex",
                py: 0,
              }}
            >
              <Button
                component={RouterLink}
                sx={{
                  color: "#ffff",
                  fontWeight: "medium",
                  justifyContent: "flex-start",
                  letterSpacing: 0,
                  py: 0.5,
                  textTransform: "none",
                  width: "100%",
                  ...(splitLoc === "saslabs"
                    ? {
                      backgroundColor: "rgb(6 57 108)",
                      color: "#2cbcd3",
                    }
                    : ""),
                  "& svg": {
                    mr: 1,
                  },
                }}
                to="/app/instance/saas"
              >
                <span>Running Labs</span>
              </Button>
            </ListItem>

          </li>
        </List>
      </Collapse>
      <ListItemButton
        disableGutters
        sx={{
          display: "flex",
          py: 0.5,
          pl: 1,
        }}
        onClick={handleClick6}
      >
        <Typography color="white" variant="h6">
          Alacarte
        </Typography>
        {open5 ? (
          <ArrowDropUpIcon style={{ marginLeft: "auto", color: "white" }} />
        ) : (
          <ArrowDropDownIcon style={{ marginLeft: "auto", color: "white" }} />
        )}
      </ListItemButton>
      <Collapse in={open6} timeout="auto" unmountOnExit>
        <Divider style={{ backgroundColor: "rgb(6 57 108)" }} />
        <List component="div" disablePadding>
          <li className="px-3 rounded-lg mb-1 text-gray-700">
            {localStorage.getItem("group") === "admin" ||
              localStorage.getItem("group") === "ops_users" ? (
              <ListItem
                disableGutters
                sx={{
                  display: "flex",
                  py: 0,
                }}
              >
                <Button
                  component={RouterLink}
                  sx={{
                    color: "#ffff",
                    fontWeight: "medium",
                    justifyContent: "flex-start",
                    letterSpacing: 0,
                    py: 0.5,
                    textTransform: "none",
                    width: "100%",
                    ...(splitLoc === "personalizedrequst"
                      ? {
                        backgroundColor: "rgb(6 57 108)",
                        color: "#2cbcd3",
                      }
                      : ""),
                    "& svg": {
                      mr: 1,
                    },
                  }}
                  to="/app/personalizedrequest"
                >
                  <span>Request</span>
                </Button>
              </ListItem>
            ) : (
              ""
            )}

            <ListItem
              disableGutters
              sx={{
                display: "flex",
                py: 0,
              }}
            >
              <Button
                component={RouterLink}
                sx={{
                  color: "#ffff",
                  fontWeight: "medium",
                  justifyContent: "flex-start",
                  letterSpacing: 0,
                  py: 0.5,
                  textTransform: "none",
                  width: "100%",
                  ...(splitLoc === "cloudlabs"
                    ? {
                      backgroundColor: "rgb(6 57 108)",
                      color: "#2cbcd3",
                    }
                    : ""),
                  "& svg": {
                    mr: 1,
                  },
                }}
                to="/app/personalizedlist"
              >
                <span>Status</span>
              </Button>
            </ListItem>

          </li>
        </List>
      </Collapse>
    </>
  );
};

export default NavItemdropdown;
